<template>
    <div id="leaguge">
        <v-row class="justify-center mt-3 pt-3">
            <h1>Liga</h1>
        </v-row>
        <v-row class="justify-center">
            <LeagueOverView /> 
        </v-row>
    </div>
</template>

<script>
import LeagueOverView from '@/components/LeagueOverView'
export default {
    name:'leaguge',
    components:{
        LeagueOverView
    },
    data(){
        return{

         }
    }
}
</script>